// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { AllowList } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Rbac/AllowList';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const useAllowLists: () => UseQueryResult<TemplateContract<AllowList>[], string> = () =>
  useOperatorBasedQuery('queryAllowLists', (ledgerApi, offset, operator) =>
    ledgerApi.queryAllowLists(offset, operator),
  );

export default useAllowLists;
